import ScreenImg from "../assets/images/svg/screenImg.svg";
import ConnplexLogo from "../assets/images/svg/connplex.svg";
import GoogleIcon from "../assets/images/svg/googleIcon.svg";
import FacebookIcon from "../assets/images/svg/facebookIcon.svg";
import AppleIcon from "../assets/images/svg/appleIcon.svg";
import PlayStore from "../assets/images/svg/playStore.svg";
import AppleStore from "../assets/images/svg/appleStore.svg";
import MorningIcon from "../assets/images/svg/morning.svg";
import AfternoonIcon from "../assets/images/svg/afternoon.svg";
import EveningIcon from "../assets/images/svg/evening.svg";
import NightIcon from "../assets/images/svg/night.svg";
import PageNotFound from "../assets/images/svg/pageNotFound.svg";
import ArrowDownIcon from "../assets/images/svg/arrowDownIcon.svg";
import TicketCancellation from "../assets/images/svg/ticket_cancellation.svg";
import MTicket from "../assets/images/svg/m_ticket.svg";
import FoodAndBeverages from "../assets/images/svg/food_and_beverages.svg";
import WheelChair from "../assets/images/svg/wheel_chair.svg";
import Parking from "../assets/images/svg/parking.svg";
import qrCode from "../assets/images/svg/qr-code.svg";
import film from "../assets/images/svg/film.svg";
import theatre from "../assets/images/svg/theatre.svg";
import seat from "../assets/images/svg/seat.svg";
import razorpay from "../assets/images/svg/razorpay.svg";
import internet from "../assets/images/svg/internet.svg";
import instagram from "../assets/images/svg/instagram.svg";
import facebook from "../assets/images/svg/facebook.svg";
import linkedin from "../assets/images/svg/linkedin.svg";
import twitter from "../assets/images/svg/twitter.svg";
import support from "../assets/images/svg/support.svg";
import ticketlogo from "../assets/images/svg/TicketLogo.svg";
import appTeatre from "../assets/images/svg/appTeatre.svg";
import Close from "../assets/images/svg/Close.svg";
import coin from "../assets/images/svg/coin.svg";
import previousImg from "../assets/images/svg/previousImg.svg";
import pdfIcon from "../assets/images/svg/pdf-icon.svg";
import crown from "../assets/images/svg/crown.svg";


const Svg = {
  Close,
  previousImg,
  ScreenImg,
  ConnplexLogo,
  GoogleIcon,
  FacebookIcon,
  AppleIcon,
  PlayStore,
  AppleStore,
  MorningIcon,
  AfternoonIcon,
  EveningIcon,
  NightIcon,
  PageNotFound,
  ArrowDownIcon,
  TicketCancellation,
  MTicket,
  FoodAndBeverages,
  WheelChair,
  Parking,
  qrCode,
  film,
  theatre,
  seat,
  razorpay,
  internet,
  instagram,
  facebook,
  linkedin,
  twitter,
  support,
  ticketlogo,
  appTeatre,
  coin,
  pdfIcon,
  crown,
};

export default Svg;
